<template>
    <ui5-select
        v-bind="$attrs"
        v-on="$listeners"
        ref="selector"
    >
        <ui5-option
            v-for="color in sortedColors"
            :color="color.htmlColor"
            :style="{ fontColor: color.htmlColor }"
            :selected="selectedValue == color.value"
            :value="color.value"
            :key="'flyColor.' + color.value"
        >
            {{ color.label }}
        </ui5-option>
    </ui5-select>
</template>

<script>
export default {
    inheritAttrs: false,
    props: {
        colors: {
            required: true,
            type: Array,
        },
        selectedValue: {
            required: false,
            default: null,
            type: String | Number,
        },
    },
    computed: {
        sortedColors() {
            return this.colors
                .slice()
                .sort((a, b) => a.label.localeCompare(b.label));
        },
    },
    updated() {
        this.colorOptions();
    },
    mounted() {
        this.colorOptions();
    },
    methods: {
        colorOptions() {
            const options = Array.from(
                this.$el.querySelectorAll('ui5-option[color]')
            );
            options.forEach((option) => {
                const interval = window.setInterval(() => {
                    const domRef = option.getDomRef();
                    if (domRef) {
                        const shadowRoot = domRef.shadowRoot;
                        if (shadowRoot) {
                            const title =
                                shadowRoot.querySelector('.ui5-li-title');
                            let square = title.querySelector('span');
                            if (!square) {
                                square =
                                    title.ownerDocument.createElement('span');
                                square.innerHTML = '&#9632;';
                                square.style.color =
                                    option.getAttribute('color');
                                title.prepend(square);
                            }
                            window.clearInterval(interval);
                        }
                    }
                }, 100);
            });

            window.setTimeout(() => {
                const select = this.$refs.selector;
                const domRefSelect = select.getDomRef();
                const root = domRefSelect.querySelector(
                    '.ui5-select-label-root'
                );
                const selectOptions = select.options;
                const selectedOption = selectOptions.find((x) => x.selected);
                const selectedOptionColor =
                    selectedOption.getAttribute('color');
                let square = root.querySelector('span');
                if (!square) {
                    square = root.ownerDocument.createElement('span');
                    square.innerHTML = '&#9632;';
                    window.lastRoot = root;
                    root.prepend(square);
                }
                square.style.color = selectedOptionColor;
            }, 0);
        },
    },
};
</script>
